import type { BackendRouteItem } from '@/types/route';

// A built-in authenticated entry, independent of role/menu configuration.
// Directory and document entitlement is always enforced by the backend.
export function withHelpCenterRoute(
  routes: BackendRouteItem[],
): BackendRouteItem[] {
  const clean = (items: BackendRouteItem[], parent = ''): BackendRouteItem[] =>
    items.flatMap((item) => {
      const path = (
        item.path.startsWith('/') ? item.path : `${parent}/${item.path}`
      )
        .replace(/\/{2,}/g, '/')
        .replace(/\/$/, '');
      if (path === '/doc' || path.startsWith('/doc/')) return [];
      return [
        {
          ...item,
          children: item.children ? clean(item.children, path) : undefined,
        },
      ];
    });
  return [
    ...clean(routes),
    {
      path: '/doc',
      name: '帮助中心',
      icon: 'ReadOutlined',
      componentKey: 'doc',
      hideInMenu: false,
    },
  ];
}
